function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
import * as React from 'react';
import isEqual from 'lodash/isEqual';
import PropTypes from 'prop-types';
import { css, StyleSheet } from "../../../styles/theme";
import Panel from "./Panel";
var styles = StyleSheet.create({
  Collapse: {
    margin: 0,
    padding: 0,
    listStyle: 'none'
  }
});

var Collapse =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Collapse, _React$Component);

  // TODO(Audrey): not sure why <React.Element<typeof Panel>> doesn not work
  function Collapse(props, context) {
    var _this;

    _classCallCheck(this, Collapse);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Collapse).call(this, props, context));
    var _this$props = _this.props,
        defaultActiveKeys = _this$props.defaultActiveKeys,
        activeKeys = _this$props.activeKeys;
    var currentActiveKeys = defaultActiveKeys;

    if ('activeKeys' in props) {
      currentActiveKeys = activeKeys;
    }

    _this.state = {
      activeKeys: currentActiveKeys
    };
    return _this;
  }

  _createClass(Collapse, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if ('activeKeys' in nextProps && !isEqual(this.props.activeKeys, nextProps.activeKeys)) {
        this.setState(function () {
          return {
            activeKeys: nextProps.activeKeys
          };
        });
      }
    }
  }, {
    key: "onToggleItem",
    value: function onToggleItem(key) {
      var activeKeys = this.state.activeKeys;

      if (this.props.isAccordion) {
        activeKeys = activeKeys[0] === key ? [] : [key];
      } else {
        activeKeys = _toConsumableArray(activeKeys);
        var index = activeKeys.indexOf(key);
        var isActive = index !== -1;

        if (isActive) {
          // remove active state
          activeKeys.splice(index, 1);
        } else {
          activeKeys.push(key);
        }
      }

      this.setActiveKeys(activeKeys);
    }
  }, {
    key: "getItems",
    value: function getItems() {
      var _this2 = this;

      var activeKeys = this.state.activeKeys;
      var isAccordion = this.props.isAccordion;
      var newChildren = [];
      React.Children.forEach(this.props.children, function (child, index) {
        if (!child) return; // If there is no key provided, use the panel order as default key

        var key = String(child.key || index);
        var _child$props = child.props;
        _child$props = _child$props === void 0 ? {} : _child$props;

        var disabled = _child$props.disabled,
            id = _child$props.id,
            rest = _objectWithoutProperties(_child$props, ["disabled", "id"]);

        var isExpanded = false;

        if (isAccordion) {
          isExpanded = activeKeys[0] === key;
        } else {
          isExpanded = activeKeys.indexOf(key) !== -1;
        }

        var props = _objectSpread({}, rest, {
          key: key,
          id: id || key,
          isExpanded: isExpanded,
          onToggle: disabled ? function () {} : function () {
            return _this2.onToggleItem(key);
          }
        });

        newChildren.push(React.cloneElement(child, props));
      });
      return newChildren;
    }
  }, {
    key: "setActiveKeys",
    value: function setActiveKeys(activeKeys) {
      this.setState(function () {
        return {
          activeKeys: activeKeys
        };
      });
      this.props.onChange(activeKeys);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          style = _this$props2.style,
          htmlAttributes = _this$props2.htmlAttributes,
          rootClassName = _this$props2.rootClassName,
          Tag = _this$props2.tag;
      return React.createElement(Tag, _extends({}, htmlAttributes, css(rootClassName, styles.Collapse), {
        style: style
      }), this.getItems());
    }
  }]);

  return Collapse;
}(React.Component);

_defineProperty(Collapse, "Panel", void 0);

_defineProperty(Collapse, "defaultProps", {
  rootClassName: '',
  style: {},
  htmlAttributes: {},
  defaultActiveKeys: [],
  onChange: function onChange() {},
  tag: 'ul'
});

Collapse.Panel = Panel;
Collapse.propTypes = {
  rootClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  htmlAttributes: PropTypes.object,
  style: PropTypes.object,
  activeKeys: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node,
  defaultActiveKeys: PropTypes.arrayOf(PropTypes.string),
  isAccordion: PropTypes.bool,
  onChange: PropTypes.func,
  tag: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};
export default Collapse;